import React, { useState, useRef, useEffect } from 'react';
import './Header.css';
import { useAuth } from './UserAccounts/AuthProvider';
import { useNavigate } from 'react-router-dom';
import ENDPOINTS from './Constants/ApiEndpoints';
import { FaBars, FaChevronDown, FaUser, FaLock, FaPowerOff, FaHospitalSymbol } from 'react-icons/fa';

const Header = ({ onToggleMenu }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const { userData, logout } = useAuth();
  const navigate = useNavigate();  

  const handleLogout = async () => {
    try {
      await logout(false);
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDropdownToggle = () => {
    setDropdownOpen((prev) => !prev);
  };

  return (
    <header className="app-header">
      {/* Left: Hamburger Menu Toggle Button */}
      <div className="header-section header-left">
        <button className="header-menu-toggle-btn" onClick={onToggleMenu} title="Toggle Sidebar">
          <FaBars size={17} />
        </button>
      </div>

      {/* Center: Hospital Logo & Brand Title */}
      <div className="header-section header-center">
        <div className="header-brand-box">
          <img src="/VThospitalsLogo.png" alt="Logo" className="header-logo-img" />
          <h1 className="header-hospital-title">VISWATEJA HOSPITAL & DIAGNOSTIC CENTRE</h1>
        </div>
      </div>

      {/* Right: User Profile & Actions */}
      <div className="header-section header-right" ref={dropdownRef}>
        <div className="user-profile-trigger" onClick={handleDropdownToggle}>
          <div className="user-avatar-circle">
            <img src="/VThospitalsLogo.png" alt="User" className="user-avatar-img" />
          </div>
          <div className="user-info-text">
            <span className="user-name">{userData?.username || 'User'}</span>
            <span className="user-role">Administrator</span>
          </div>
          <FaChevronDown size={11} className="dropdown-caret" />
        </div>

        {dropdownOpen && (
          <div className="header-dropdown-card animated-popup">
            <div className="dropdown-user-header">
              <strong>{userData?.username || 'User'}</strong>
              <small>Staff Account</small>
            </div>
            <div className="dropdown-divider" />
            <div className="dropdown-item">
              <FaUser className="dropdown-icon" /> My Profile
            </div>
            <div className="dropdown-item">
              <FaLock className="dropdown-icon" /> Change Password
            </div>
            <div className="dropdown-divider" />
            <div className="dropdown-item logout-item" onClick={handleLogout}>
              <FaPowerOff className="dropdown-icon" /> Log Out
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
